/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable camelcase */
export default {
  s3: {
    transcodedMedia: {
      REGION: process.env.REACT_APP_S3_TRANSCODED_UPLOADS_BUCKET_REGION,
      BUCKET: process.env.REACT_APP_S3_TRANSCODED_UPLOADS_BUCKET
    },
    profilePictures: {
      REGION: process.env.REACT_APP_S3_PROFILE_PICTURE_UPLOADS_BUCKET_REGION,
      BUCKET: process.env.REACT_APP_S3_PROFILE_PICTURE_UPLOADS_BUCKET
    }
  },
  apiGateway: {
    apartments: {
      REGION: process.env.REACT_APP_API_GATEWAY_REGION,
      URL: process.env.REACT_APP_APARTMENTS_API_GATEWAY_URL
    },
    users: {
      REGION: process.env.REACT_APP_API_GATEWAY_REGION,
      URL: process.env.REACT_APP_USERS_API_GATEWAY_URL
    },
    applications: {
      REGION: process.env.REACT_APP_API_GATEWAY_REGION,
      URL: process.env.REACT_APP_APPLICATIONS_API_GATEWAY_URL
    },
    showings: {
      REGION: process.env.REACT_APP_API_GATEWAY_REGION,
      URL: process.env.REACT_APP_SHOWINGS_API_GATEWAY_URL
    },
    applicantAvailability: {
      REGION: process.env.REACT_APP_API_GATEWAY_REGION,
      URL: process.env.REACT_APP_APPLICANTAVAILABILITY_API_GATEWAY_URL
    },
    instantRent: {
      REGION: process.env.REACT_APP_API_GATEWAY_REGION,
      URL: process.env.REACT_APP_INSTANTRENT_API_GATEWAY_URL
    }
  },
  cognito: {
    REGION: process.env.REACT_APP_COGNITO_REGION,
    USER_POOL_ID: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    APP_CLIENT_ID: process.env.REACT_APP_COGNITO_APP_CLIENT_ID,
    IDENTITY_POOL_ID: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID
  },
  iot: {
    aws_pubsub_region: process.env.REACT_APP_IOT_REGION,
    aws_pubsub_endpoint: `wss://${process.env.REACT_APP_IOT_ENDPOINT}/mqtt`
  }
}
